import moment from 'moment';

export const STATUS_1031_BUYER = '1031 Buyer';
export const STATUS_ID_PERIOD_OVER = 'ID Period Over';
export const STATUS_PASSIVE_INVESTOR = 'Passive Investor';
export const STATUS_ACTIVE_INVESTOR = 'Active Investor';

export const DEFAULT_INVESTOR_STATUS = STATUS_PASSIVE_INVESTOR;

// 1031 exchange deadlines, counted from the Date of Down Leg
export const ID_PERIOD_DAYS = 45;
export const EXCHANGE_PERIOD_DAYS = 180;

const DATE_FORMATS = ['MM/DD/YYYY', 'YYYY-MM-DD'];

// Returns the status an investor should currently have, rolling
// "1031 Buyer" forward to "ID Period Over" after 45 days from the
// date of down leg and to "Passive Investor" after 180 days.
export function resolveInvestorStatus(status, dateOfDownLeg) {
    if (status !== STATUS_1031_BUYER && status !== STATUS_ID_PERIOD_OVER)
        return status;
    if (!dateOfDownLeg)
        return status;

    const downLeg = moment(dateOfDownLeg, DATE_FORMATS);
    if (!downLeg.isValid())
        return status;

    const daysElapsed = moment().startOf('day').diff(downLeg.startOf('day'), 'days');
    if (daysElapsed >= EXCHANGE_PERIOD_DAYS)
        return STATUS_PASSIVE_INVESTOR;
    if (daysElapsed >= ID_PERIOD_DAYS)
        return STATUS_ID_PERIOD_OVER;
    return STATUS_1031_BUYER;
}

export default [
    STATUS_1031_BUYER,
    STATUS_ID_PERIOD_OVER,
    STATUS_PASSIVE_INVESTOR,
    STATUS_ACTIVE_INVESTOR,
];
